import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Bell, Gauge, ThermometerSun, Map, Search, Heart } from 'lucide-react';
import { IntelligenceLayout } from './IntelligenceLayout';
import SignalScannerView from './SignalScannerView';
import GrowthMomentumView from './GrowthMomentumView';
import TalentShortageIndex from './TalentShortageIndex';
import GeoHeatmap from './GeoHeatmap';
import IntelligenceExplorer from './IntelligenceExplorer';
import CoverageDiagnostics from './CoverageDiagnostics';

const TABS = [
  { key: 'hiring-scanner', label: 'Hiring Scanner', icon: Bell, Component: SignalScannerView },
  { key: 'growth-momentum', label: 'Growth & Momentum', icon: Gauge, Component: GrowthMomentumView },
  { key: 'talent-shortage', label: 'Talent Shortage', icon: ThermometerSun, Component: TalentShortageIndex },
  { key: 'geo-heatmap', label: 'Geo Heatmap', icon: Map, Component: GeoHeatmap },
  { key: 'explorer', label: 'Job Explorer', icon: Search, Component: IntelligenceExplorer },
  { key: 'coverage-diagnostics', label: 'Coverage Diagnostics', icon: Heart, Component: CoverageDiagnostics },
];

const DEFAULT_TAB = 'growth-momentum';

export default function SignalFeedsHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    TABS.some(t => t.key === requestedTab) ? requestedTab : DEFAULT_TAB
  );

  const handleTabClick = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  const ActiveComponent = TABS.find(t => t.key === activeTab)?.Component || GrowthMomentumView;
  const extraProps = activeTab === 'hiring-scanner' || activeTab === 'growth-momentum'
    ? { initialMode: searchParams.get('mode') || (activeTab === 'hiring-scanner' ? 'recent' : 'pressure') }
    : {};

  return (
    <IntelligenceLayout title="Signal Feeds">
      <div className="border-b border-gray-200 bg-white px-6 pt-4 sticky top-0 z-10" data-testid="signal-feeds-hub-tabs">
        <div className="flex items-center gap-1 overflow-x-auto">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab.key)}
              data-testid={`signal-feeds-tab-${tab.key}`}
              className={`flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-medium rounded-t-lg border-b-2 whitespace-nowrap transition-colors ${
                activeTab === tab.key
                  ? 'text-[#0A1F44] border-[#D4AF37] bg-[#fdf9ef]'
                  : 'text-gray-500 border-transparent hover:text-[#0A1F44] hover:bg-gray-50'
              }`}
            >
              <tab.icon className="h-3.5 w-3.5" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <ActiveComponent embedded {...extraProps} />
    </IntelligenceLayout>
  );
}
